import { CssBaseline } from "@mui/material";
import { LanguagesProvider } from "./context/LanguagesContext";
import { PortalProvider } from "./context/PortalsContext";
import { AuthProvider } from "./context/AuthContext";
import { LoaderProvider } from "./context/LoaderContext";
import { ToastProvider } from "./context/ToastContext";
import Routes from "./routes";
import AppTheme from "./theme/AppTheme";
import { CustomisationProvider } from "./context/CustomisationContext";
import { TranslationProvider } from "./context/TranslationContext";
import { PageMetadataProvider } from "./context/PageMetadataContext";

const App = () => {
  return (
    <AuthProvider>
      <PortalProvider>
        <PageMetadataProvider>
          <LanguagesProvider>
            <CustomisationProvider>
              <TranslationProvider>
                <LoaderProvider>
                  <ToastProvider>
                    <AppTheme>
                      <CssBaseline enableColorScheme />
                      <Routes />
                    </AppTheme>
                  </ToastProvider>
                </LoaderProvider>
              </TranslationProvider>
            </CustomisationProvider>
          </LanguagesProvider>
        </PageMetadataProvider>
      </PortalProvider>
    </AuthProvider>
  );
};

export default App;
